<template>
  <section class="section" :class="classes">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="row justify-content-center" v-if="pagination">
            <base-pagination :total="total_dubladores" :per-page="20" v-model="page" align="center" :desabilitado="$wait.is('dublador.load')"></base-pagination>
          </div>
          <v-wait for="dublador.load"> 
            <template slot="waiting">
              <div class="row row-grid">
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
              </div>
            </template>
            <div class="row justify-content-center" v-if="!dubladores.length">
              <div class="col-lg-7">
                <div class="card shadow bg-gradient-secondary mb-3">
                  <div class="card-body p-lg-5">
                    <h4 class="mb-1 text-center">Não foi possível encontrar nenhum(a) dublador(a)!</h4>
                    <p class="mt-0 text-center">Tente utilizar outro termo de pesquisa.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row row-grid" v-else>
              <dublador-card v-for="person in dubladores" :person="person" v-bind:key="person.id"></dublador-card>
            </div>
          </v-wait>
          <div class="row justify-content-center" v-if="pagination">
            <base-pagination :total="total_dubladores" :per-page="20" v-model="page" align="center" :desabilitado="$wait.is('dublador.load')"></base-pagination>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import dubladorCard from './DubladorCard';
import movieCardPlaceholder from './MovieCardPlaceholder';

import BasePagination from '@/components/BasePagination';

export default {
  components: { dubladorCard, movieCardPlaceholder, BasePagination },
  name: "dubladorCardDeck",
  props: {
    classes: {
      type: [String, Object, Array],
      description: "Individual card css classes"
    },
    cardClasses: {
      type: [String, Object, Array],
      description: "Individual card css classes"
    },
    pagination: {
      type: Boolean,
      default: false
    },
    dubladorList: {
      type: Array,
      default: () => { return [] }
    },
  },
  data() {
    return {
      endpoint: '/v1/dubladores/',
      dubladores: [],
      total_dubladores: 100,
      page: ( !this.$route.query.pagina ) ? 1 : parseInt(this.$route.query.pagina),
      termo: ( !this.$route.query.termo ) ? '' : this.$route.query.termo,
    }
  },
  watch: {
    page(newValue) {
      this.$router.push({ query: { ...this.$route.query, pagina: newValue }});
    },
    '$route' (to, from) {
      this.page = ( !this.$route.query.pagina ) ? 1 : parseInt(this.$route.query.pagina)
      this.termo =  ( !this.$route.query.termo ) ? '' : this.$route.query.termo;
      this.loadDublador();
    }
  },
  methods: {
    makeURLparams(data) {
      return Object.keys(data).map(key => `${key}=${encodeURIComponent(data[key])}`).join('&');
    },
    async loadDublador() {
      this.$wait.start('dublador.load');
      if (this.dubladorList.length) {
        this.total_dubladores = this.dubladorList.length;
        this.dubladores = this.dubladorList;
        this.$wait.end('dublador.load');
      }else {
        var objQuery = {};

        let checkSearchQuery = ( this.termo !== '' ) ? true : false;
        let checkPageQuery = ( this.page > 0 ) ? true : false;


        if ( checkSearchQuery == true ) {
          objQuery['search'] = this.termo;
        }

        if ( checkPageQuery == true ) {
          objQuery['page'] = this.page;
        }

        var queryString = '?'+this.makeURLparams(objQuery);

        
        this.axios.get(this.endpoint+queryString)
          .then(response => {
            this.total_dubladores = response.data.count;
            this.dubladores = response.data.results;
          })
          .catch(e => {
            //console.log(e.message)
          })
          .then(data => {
            this.$wait.end('dublador.load');
          }); 
      }
      
      },
  },
  created() {
    this.loadDublador();
  }
};
</script>
<style>
  .v-select.form-control {
    padding-top: 0.425rem;
  }
  .v-select.vs--disabled {
    background: #e9ecef;
  }
  .vs__clear {
    margin-right: 9px;
    margin-top: -5px;
  }
</style>
